import React, { useState } from 'react';
import cn from 'classnames';

import { DocIcon, IconParams, Icons, Text, Wrapper } from 'widget/components';
import { useIsMutedDark, useIsPrimaryDark } from 'widget/hooks';

import { useFilename } from './hooks';

interface Doc {
  src: string;
}

const Doc = ({ src }: Doc) => {
  const [isLoading, setIsLoading] = useState(false);

  const filename = useFilename(src);
  const isMutedDark = useIsMutedDark();
  const isPrimaryDark = useIsPrimaryDark();

  const getObjectUrl = async () => {
    const res = await fetch(src)
      .then(res => res.blob())
      .catch(() => null);

    if (!res) return null;

    const objectURL = URL.createObjectURL(res);
    return objectURL;
  };

  const handleClick = async () => {
    setIsLoading(true);

    const objectUrl = await getObjectUrl();
    const a = document.createElement('a');

    a.download = filename || 'download';
    a.href = objectUrl || src;
    a.target = objectUrl ? '_self' : '_blank';

    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);

    setIsLoading(false);
  };

  const fileNameColor = isMutedDark ? 'white' : 'dark';

  const iconParams: IconParams = {
    fill: isMutedDark ? 'white' : !isPrimaryDark ? 'dark' : undefined,
    size: 20,
  };

  return (
    <div
      className={cn('whatcrm-widget-doc', {
        'whatcrm-widget-doc_disabled': isLoading,
      })}
      onClick={handleClick}
    >
      <DocIcon filename={filename} />

      <Wrapper flexDirection="column" style={{ minWidth: 0 }}>
        {filename && (
          <Text color={fileNameColor} isEllipsis>
            {filename}
          </Text>
        )}

        {isLoading ? (
          <Icons.CircleNotch {...iconParams} />
        ) : (
          <Icons.ArrowDown {...iconParams} />
        )}
      </Wrapper>
    </div>
  );
};

export default Doc;
